import React from "react";
import PropTypes from "prop-types";

import Right from "./icons/Right";
import Checkmark from "./icons/Checkmark";
import Clipboard from "./icons/Clipboard";
import Close from "./icons/Close";
import CreditCard from "./icons/CreditCard";
import Euro from "./icons/Euro";
import Exclamation from "./icons/Exclamation";
import Hide from "./icons/Hide";
import LongRight from "./icons/LongRight";
import Question from "./icons/Question";
import Reveal from "./icons/Reveal";
import Today from "./icons/Today";
import User from "./icons/User";
import ThemeContext from "../utils/theme";

const ICONS = {
  checkmark: Checkmark,
  clipboard: Clipboard,
  close: Close,
  "credit-card": CreditCard,
  euro: Euro,
  exclamation: Exclamation,
  hide: Hide,
  "long-right": LongRight,
  question: Question,
  reveal: Reveal,
  right: Right,
  today: Today,
  user: User,
};

export default function Icon({ color, symbol, ...restProps }) {
  const { colorSecondary } = React.useContext(ThemeContext);
  const Component = ICONS[symbol] || null;

  return Component && <Component {...restProps} color={color || colorSecondary} />;
}

Icon.propTypes = {
  color: PropTypes.string,
  symbol: PropTypes.oneOf([
    "checkmark",
    "clipboard",
    "close",
    "credit-card",
    "euro",
    "exclamation",
    "hide",
    "long-right",
    "question",
    "reveal",
    "right",
    "today",
    "user",
  ]),
};
